// API配置文件
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '/api'  // 生产环境通过Nginx或Ingress代理
    : '/api'); // 开发环境使用proxy代理

export const API = {
  // DDD概念
  concepts: `${API_BASE_URL}/ddd/concepts`,
  
  // 运输单
  shipments: `${API_BASE_URL}/shipments`,
  shipmentCost: (id) => `${API_BASE_URL}/shipments/${id}/cost`,
  updateShipmentStatus: (id) => `${API_BASE_URL}/shipments/${id}/status`,
  
  // 客户
  customers: `${API_BASE_URL}/customers`,
  
  // 业务场景
  scenarios: `${API_BASE_URL}/scenarios`,
  
  // 知识库
  knowledgeDocuments: `${API_BASE_URL}/knowledge/documents`,
  knowledgeSearch: `${API_BASE_URL}/knowledge/search`,
  knowledgeAsk: `${API_BASE_URL}/knowledge/ask`,
  
  // RAGFlow兼容接口
  ragflowKnowledgebases: `${API_BASE_URL}/knowledge/ragflow/knowledgebases`,
  
  // 实体提取
  extractEntities: `${API_BASE_URL}/extract-entities`
};

// API请求工具函数
export const fetchAPI = async (url, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  };

  try {
    const response = await fetch(url, defaultOptions);
    
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

// 导出API基础URL供其他模块使用
export const getApiBaseUrl = () => API_BASE_URL;